import { render, staticRenderFns } from "./InformationPreloader.vue?vue&type=template&id=215be202&scoped=true&"
var script = {}
import style0 from "./InformationPreloader.vue?vue&type=style&index=0&id=215be202&scoped=true&lang=css&"
import style1 from "./InformationPreloader.vue?vue&type=style&index=1&id=215be202&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215be202",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('215be202')) {
      api.createRecord('215be202', component.options)
    } else {
      api.reload('215be202', component.options)
    }
    module.hot.accept("./InformationPreloader.vue?vue&type=template&id=215be202&scoped=true&", function () {
      api.rerender('215be202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/InformationPreloader.vue"
export default component.exports